import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, InjectionToken, input, Provider } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SharedUiSocialLoginChipComponent } from '../shared-ui-social-login-chip/shared-ui-social-login-chip.component';

export const SOCIAL_LOGIN_GOOGLE = new InjectionToken<string>('SOCIAL_LOGIN_GOOGLE');
export function provideGoogleUrl(url: string): Provider {
  return { provide: SOCIAL_LOGIN_GOOGLE, useValue: url };
}

export const SOCIAL_LOGIN_APPLE = new InjectionToken<string>('SOCIAL_LOGIN_APPLE');
export function provideAppleUrl(url: string): Provider {
  return { provide: SOCIAL_LOGIN_APPLE, useValue: url };
}

@Component({
  selector: 'enx-shared-ui-social-login',
  standalone: true,
  imports: [CommonModule, SharedUiSocialLoginChipComponent, TranslateModule],
  templateUrl: './shared-ui-social-login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiSocialLoginComponent {
  bigVersion = input<boolean>(false);
  googleId = input<string>('');
  appleId = input<string>('');
  enabled = input<boolean>(true);

  suffixLabel = computed(() => (this.bigVersion() ? '-long' : ''));

  readonly SOCIAL_LOGIN_GOOGLE = inject(SOCIAL_LOGIN_GOOGLE);
  readonly SOCIAL_LOGIN_APPLE = inject(SOCIAL_LOGIN_APPLE);
}
